import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import InfoIcon from "../../images/info.svg";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NoAttachmentsImage from "../../images/Clear-filter.svg";
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Input,
  InputAdornment,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
} from "@mui/material";
import { DateIconSvg, ListIconSvg, PersonIconSvg } from "../../images/SvgIcons";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL,
  INSERT_INVOICE_ATTCHMEMNTS,
} from "../../constants/ApiRoute";
import { authHeader } from "../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import API from "../comman/API";
import { useToast } from "../comman/CustomMessages";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function PrintConsolidatedInvoiceModel(props) {
  const {
    open,
    billingStatementDetail,
    invoiceNumber,
    setOpenPrintInvoiceModel,
  } = props;
  // const [open, setOpen] = React.useState(false);
  console.log(
    billingStatementDetail,
    "billingStatementDetailbillingStatementDetail"
  );
  const theme = useTheme();
  const showToast = useToast();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [attachmentLoading, setAttachemntLoading] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [attachmentFileObject, setAttachmentFileObject] = React.useState([]);
  const [checkboxFilter, setCheckboxFilter] = React.useState([]);
  console.log(attachmentFileObject, "attachmentFileObjectattachmentFileObject");
  console.log(checkboxFilter, "checkboxFiltercheckboxFilter");
  const supportedFormats = ["svg", "jpg", "jpeg", "webp", "png", "pdf"];
  const handleCancel = () => {
    setOpenPrintInvoiceModel(false);
  };

  const createPayload = (attachmentFileObject) => {
    // Filter files with supported formats
    const supportedFiles = attachmentFileObject.filter((item) => {
      const fileExtension = item.FileName.split(".").pop().toLowerCase();
      return supportedFormats.includes(fileExtension);
    });

    // Create payload for supported files
    const payload = supportedFiles.map((file) => ({
      filePath: file.Path,
      fileName: file.FileName,
      userId: file.UserID,
    }));

    return payload;
  };

  const handleFileUpdate = async () => {
    const payload = createPayload(checkboxFilter);
    console.log(payload, "iiiiiiiiiii");
    setLoading(true);
    console.log(payload, "jjjjjjjjj");
    let postObj = {
      invoiceId: invoiceNumber,
      details: payload,
    };
    console.log(payload, "kkkkkkkkkk");
    const config = {
      method: "POST",
      url: INSERT_INVOICE_ATTCHMEMNTS,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postObj)),
        flutterString: "",
      },
    };
    console.log(payload, "lllllllllllllll");
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      console.log(parsedResponse, "parsedResponseparsedResponseu");
      if (parsedResponse.status === "Success") {
        window.open(
          `/print-consolidatedinvoice-form/${invoiceNumber}`,
          "_blank"
        );
        setOpenPrintInvoiceModel(false);
        // showToast("Description updated successfully", "success");
      }
      setLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v?.message, "error");
      }
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

   const attachmentInvoiceId =
    invoiceNumber || billingStatementDetail?.[0]?.InvoiceId;

  const getAttachmentListByProjectId = async () => {
    setAttachemntLoading(true);
    const config = {
      method: "GET",
      url: GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(
          JSON.stringify({
            // projectId: billingStatementDetail[0].ProjID,
            // periodKey: billingStatementDetail[0].PeriodKey,
            // userId: billingStatementDetail[0]?.UserID,
            userId: null,
            billingStatementId: attachmentInvoiceId,
            parentTypeId: 2,
          })
        ),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log("parse", parsedResponse);

      if (parsedResponse.status == "Success") {
        const sortedData = parsedResponse.data.sort((a, b) => {
          // Extract file extensions
          const extA = a.FileName.split('.').pop().toLowerCase();
          const extB = b.FileName.split('.').pop().toLowerCase();
        
          // Get the indices from the custom order
          const indexA = supportedFormats.indexOf(extA);
          const indexB = supportedFormats.indexOf(extB);
        
          // Sort based on the index in the custom order
          return indexA - indexB;
        });
        setAttachmentFileObject(sortedData);
      }
      setAttachemntLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        //showToast(v.message, "error");
      }
      setAttachemntLoading(false);
    }
  };

  React.useEffect(() => {
    getAttachmentListByProjectId();
  }, [attachmentInvoiceId]);

  React.useEffect(() => {
    const initialCheckedFiles = attachmentFileObject.filter((item) => {
      const fileExtension = item.FileName.split(".").pop().toLowerCase();
      return supportedFormats.includes(fileExtension); // Only add supported files
    });

    setCheckboxFilter(initialCheckedFiles); // Set initial checked files
  }, [attachmentFileObject]);

  const handleCheckBox = (e, item) => {
    const { checked } = e.target;

    if (checked) {
      // Add the file to the filter if checked
      setCheckboxFilter((prev) => [...prev, item]);
    } else {
      // Remove the file from the filter if unchecked
      setCheckboxFilter((prev) =>
        prev.filter((selected) => selected.attachmentId !== item.attachmentId)
      );
    }

    console.log(
      `${item.FileName} is ${checked ? "checked" : "unchecked"}`,
      checkboxFilter
    );
  };
  return (
    <>
      <Dialog
        className="user-filter-popup detach-model"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        // onClose={resetFilter}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "26px 34px", pb: "8px" }}
          direction="row"
          alignItems="center"
          spacing={1}
          justifyContent="flex-start"
        >
          <Typography className="model-title">Invoice Attachments: </Typography>
          {/* <img src={InfoIcon} /> */}
        </Stack>
        <Box sx={{ p: "0px 34px 10px 34px", maxHeight: "360px" }}>
          <Grid container alignItems="center" spacing={1}>
            {/* Note Symbol */}
            {/* <Grid item>
    <InfoOutlinedIcon sx={{ color: "#007BFF" }} />
  </Grid> */}
            {/* Highlighted Text */}
            <Grid item>
              <Typography
                sx={{
                  color: "#007BFF", // Blue color for text
                  fontSize: "14px", // Optional: Adjust font size if needed
                  fontWeight: 500, // Optional: Slightly bold text for emphasis
                }}
              >
                *Only attachments in PDF, PNG, JPG, JPEG, WebP, and SVG formats
                will be included in the invoice PDF for printing or downloading.
                Attachments will not be included when downloading the invoice in
                other formats like Excel, Word or Image.
              </Typography>
            </Grid>
          </Grid>
          <Box sx={{ maxHeight: "335px", height: "100%", overflowY: "scroll" }}>
          {attachmentLoading && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%", // Adjust height based on the container
                marginTop: "3rem",
              }}
            >
              <CircularProgress />
            </Box>
          )}

          {!attachmentLoading ? (
            attachmentFileObject?.length > 0 ? (
              attachmentFileObject.map((item, index) => {
                console.log(item, "itemmmmmmmmmmm");
                // Extract file extension from the FileName
                const fileExtension = item.FileName.split(".")
                  .pop()
                  .toLowerCase();
                const isSupported = supportedFormats.includes(fileExtension);

                return (
                  <FormGroup key={index} sx={{ marginBottom: "8px",                         lineBreak: "anywhere",
                    paddingRight: "5px", }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {/* Checkbox */}
                      <Checkbox
                        checked={checkboxFilter.some(
                          (selected) =>
                            selected.attachmentId === item.attachmentId
                        )} // Check if the file is in the selected list (initially checked for supported files)
                        disabled={!isSupported} // Disable if the format is unsupported
                        onChange={(event) => handleCheckBox(event, item)} // Handle changes
                      />
                      {/* Filename */}
                      <span
                        style={{
                          fontSize: "14px",
                          color: isSupported ? "#212121" : "#acacac", // Highlight unsupported files in red
                          marginLeft: "8px",
                          // textDecoration: !isSupported
                          //   ? "line-through"
                          //   : "none", // Add a strikethrough for unsupported files
                        }}
                      >
                        {item?.FileName}
                      </span>
                    </div>
                  </FormGroup>
                );
              })
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  marginTop: "20px",
                  padding: "20px",
                }}
              >
                {/* Display Image or Icon for "No Attachments Found" */}
                <img
                  src={NoAttachmentsImage} // You can use any image or icon for "No Attachments Found"
                  alt="No Attachments"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "contain",
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{ marginTop: "10px" }}
                  className="no-data-text"
                >
                  No Attachments Found.
                </Typography>
              </Box>
            )
          ) : (
            ""
          )}
        </Box>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 34px", pt: "25px" }}
        >
          {!attachmentLoading ? (
            <Button
              className={loading ? "disable-filter-btn" : "filter-btn"}
              onClick={handleFileUpdate}
              disabled={loading}
            >
              {loading && (
                <CircularProgress
                  color={"inherit"}
                  size={10}
                  sx={{ marginRight: "3px" }}
                />
              )}
              Proceed
            </Button>
          ) : (
            ""
          )}
          <Button className="cancel-btn" onClick={handleCancel}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
